export const EMPLOYEE_LOADING = "EMPLOYEE_LOADING";
export const EMPLOYEE_RESET = "EMPLOYEE_RESET";
export const GET_EMPLOYEE = "GET_EMPLOYEE";
export const GET_EMPLOYEE_ONE = "GET_EMPLOYEE_ONE";
export const GET_EMPLOYEE_SUCCESS = "GET_EMPLOYEE_SUCCESS";
export const GET_EMPLOYEE_FAIL = "GET_EMPLOYEE_FAIL";
export const DELETE_EMPLOYEE = "DELETE_EMPLOYEE"
export const DELETE_EMPLOYEE_SUCCESS = "DELETE_EMPLOYEE_SUCCESS"
export const DELETE_EMPLOYEE_FAIL = "DELETE_EMPLOYEE_FAIL"
export const UPDATE_EMPLOYEE = "UPDATE_EMPLOYEE"
export const UPDATE_EMPLOYEE_SUCCESS = "UPDATE_EMPLOYEE_SUCCESS"
export const UPDATE_EMPLOYEE_FAIL = "UPDATE_EMPLOYEE_FAIL"
export const ADD_NEW_EMPLOYEE = "ADD_NEW_EMPLOYEE"
export const ADD_EMPLOYEE_SUCCESS = "ADD_EMPLOYEE_SUCCESS"
export const ADD_EMPLOYEE_FAIL = "ADD_EMPLOYEE_FAIL"